const headerStyle = theme => ({
    paymentHeader: { minWidth: 'max-content' },
    autoWidth: { width: 'auto' },
    alertAction: { padding: 0 },
    cancelButton: { marginRight: theme.spacing(1) },
});

export default headerStyle;
